import React from 'react';
import { SaveIcon } from 'lucide-react';
interface SettingsTabProps {
  brandId: number;
}
export const SettingsTab: React.FC<SettingsTabProps> = ({
  brandId
}) => {
  return <div className="space-y-6" data-id="element-219">
      <div className="bg-white shadow-sm rounded-lg p-6" data-id="element-220">
        <h2 className="text-lg font-medium text-gray-900 mb-6" data-id="element-221">
          Brand Settings
        </h2>
        <form className="space-y-6" data-id="element-222">
          <div data-id="element-223">
            <label htmlFor="brandName" className="block text-sm font-medium text-gray-700" data-id="element-224">
              Brand Name
            </label>
            <input type="text" name="brandName" id="brandName" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" defaultValue={brandId === 1 ? 'Acme Inc' : brandId === 2 ? 'TechGiant' : 'SecureWeb'} data-id="element-225" />
          </div>
          <div data-id="element-226">
            <label htmlFor="primaryDomain" className="block text-sm font-medium text-gray-700" data-id="element-227">
              Primary Domain
            </label>
            <input type="text" name="primaryDomain" id="primaryDomain" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" defaultValue={brandId === 1 ? 'acmeinc.com' : brandId === 2 ? 'techgiant.com' : 'secureweb.com'} data-id="element-228" />
            <p className="mt-2 text-sm text-gray-500" data-id="element-229">
              This is your main website domain that we'll use as a reference.
            </p>
          </div>
          <div data-id="element-230">
            <label htmlFor="scanFrequency" className="block text-sm font-medium text-gray-700" data-id="element-231">
              Scan Frequency
            </label>
            <select id="scanFrequency" name="scanFrequency" className="mt-1 block w-full pl-3 pr-10 py-2 text-base border border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md" defaultValue="daily" data-id="element-232">
              <option value="hourly" data-id="element-233">Every Hour</option>
              <option value="daily" data-id="element-234">Daily</option>
              <option value="weekly" data-id="element-235">Weekly</option>
              <option value="monthly" data-id="element-236">Monthly</option>
            </select>
          </div>
          <div data-id="element-237">
            <label htmlFor="alertEmail" className="block text-sm font-medium text-gray-700" data-id="element-238">
              Alert Email
            </label>
            <input type="email" name="alertEmail" id="alertEmail" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" defaultValue="alerts@company.com" data-id="element-239" />
            <p className="mt-2 text-sm text-gray-500" data-id="element-240">
              We'll send alerts to this email when new potential threats are
              detected.
            </p>
          </div>
          <div className="flex justify-end" data-id="element-241">
            <button type="submit" className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700" data-id="element-242">
              <SaveIcon className="h-4 w-4 mr-2" data-id="element-243" />
              Save Settings
            </button>
          </div>
        </form>
      </div>
    </div>;
};